import style from './style/ShippingTable.scss';
import { Desktop, Mobile } from '../../../helpers/MediaQueries';
import CurrencyService from '../../../services/CurrencyService';

const ShippingTable = ({ countries }) => {
	const shippingTableRows = [];
	// Sadly, preact does not support returns of array's in render method..
	countries.forEach(country => {
		renderShippingTableRows(country).forEach((deliveryServiceRow) => {
			shippingTableRows.push(deliveryServiceRow);
		});
	});

	return (
		<table class={`table table-sm ${style.shipping}`}>
			<thead>
				<tr>
					<th>Country</th>
					<th>Shipping</th>
					<th className={style.price}>Price</th>
					<th>
						<Desktop>Delivery time (business day)</Desktop>
						<Mobile>Delivery time</Mobile>
					</th>
				</tr>
			</thead>
			<tbody>
				{shippingTableRows}
			</tbody>
		</table>
	);
};

/**
 * @param {{name: string, deliveryServices: DeliveryService[]}} country
 */
const renderShippingTableRows = (country) => {
	const rowSpan = country.deliveryServices.length;
	const countryName = country.name;
	return country.deliveryServices.map((deliveryService, i) => <ShippingTableDeliveryServiceRow {...{ i, rowSpan, countryName, deliveryService }} />);
};

/**
 * @param {number} i
 * @param {number} rowSpan
 * @param {string} countryName
 * @param {DeliveryService} deliveryService
 */
const ShippingTableDeliveryServiceRow = ({ i, rowSpan, countryName, deliveryService }) => (
	<tr>
		{ i === 0
			? <td rowSpan={rowSpan}>{countryName}</td>
			: null
		}
		<td>{deliveryService.carrierName}</td>
		<td>{CurrencyService.format(deliveryService.price)}</td>
		<td>{deliveryService.deliveryTime}</td>
	</tr>
);

export default ShippingTable;



// WEBPACK FOOTER //
// ./components/blocks/shippingPage/ShippingTable.js